/** 파티클 클릭 샘플. 상품은 CATALOG 4종을 공유하고, 장면 JSON은 모델별 엔진 출력이다. */
import {
  ABSA_BY_ID,
  ANOMALY_BY_ID,
  CATALOG,
  demoEmbedding,
  FORECAST_BY_ID,
  PMF_BY_ID,
  PMF_SCORES,
  SALES_BY_ID,
} from './engine/pmfEngine.js';

function J(obj) {
  return JSON.stringify({ demo: true, ...obj }, null, 2);
}

const PRODUCTS = CATALOG.products;
const P1 = PRODUCTS[0];
const S1 = PMF_BY_ID[P1.product_id];
const A1 = ABSA_BY_ID[P1.product_id];
const F1 = FORECAST_BY_ID[P1.product_id];
const N1 = ANOMALY_BY_ID[P1.product_id];
const H1 = SALES_BY_ID[P1.product_id];

const OVERVIEW = [
  {
    kicker: 'ID · System Map',
    title: '전체 연결',
    items: [
      { name: '원천 4종', kind: 'SRC', json: J({ sources: ['web_product', 'review_cs', 'public_data', 'event_log'], join: ['product_id', 'sku'] }) },
      { name: '패브릭', kind: '01', json: J({ task: 1, role: '이종 원천 → 표준 자산', layers: ['collect', 'hub', 'process', 'store', 'api'] }) },
      { name: 'XAI', kind: '02', json: J({ task: 2, role: '리뷰·광고·판매 → 요인', output: ['absa', 'weighted_components'] }) },
      { name: '수요예측', kind: '03', json: J({ task: 3, role: '시계열 → p10/p50/p90', output: ['quantile_forecast', 'order'] }) },
      { name: '이상탐지', kind: '04', json: J({ task: 4, role: '스트림 → 이상 점수', output: ['anomaly_score', 'alert'] }) },
      { name: 'PMF', kind: '05', json: J({ task: 5, role: '모델 합산 → 시장 적합성', formula: S1.formula }) },
    ],
  },
  {
    kicker: 'SRC · 원천',
    title: '이종 원천 4갈래',
    items: [
      { name: 'web_product', kind: 'JSON API', json: J({ product_id: P1.product_id, sku: P1.sku, product_name: P1.product_name, price: P1.price, stock: P1.stock, channel: P1.channel }) },
      { name: 'review_cs', kind: '텍스트', json: J({ product_id: P1.product_id, reviews: P1.reviews, cs: P1.cs }) },
      { name: 'public_data', kind: '공공·검색', json: J({ ...CATALOG.market, search_interest: P1.search_trend }) },
      { name: 'event_log', kind: '이벤트', json: J({ event_type: 'purchase', product_id: P1.product_id, count: P1.ad_metrics.purchase }) },
      { name: 'join key', kind: '축', json: J({ product_id: P1.product_id, sku: P1.sku, catalog: PRODUCTS.map((p) => p.product_id) }) },
    ],
  },
  {
    kicker: 'FAB · 패브릭',
    title: '표준화 5층',
    items: [
      { name: 'Layer1 수집', kind: '봉투', json: J({ source: 'web_product', record_id: `${P1.product_id}-web`, payload: { product_id: P1.product_id, sku: P1.sku } }) },
      { name: 'Layer2 허브', kind: 'Kafka', json: J({ topics: ['product_signal', 'review_stream', 'market_stream', 'sale_event'] }) },
      { name: 'Layer3 가공', kind: '특징', json: J({ features: { sentiment_score: A1.channel_score, stock: P1.stock, search_index: P1.search_trend.index } }) },
      { name: 'Layer4 저장', kind: '3중', json: J({ redis: `hot:${P1.product_id}`, s3: `s3://hdf/dt=${CATALOG.as_of}/${P1.product_id}.json`, milvus: P1.product_id }) },
      { name: 'Layer5 API', kind: 'REST', json: J({ feeds: ['xai', 'forecast', 'anomaly', 'pmf'] }) },
    ],
  },
  {
    kicker: 'MOD · 3모델',
    title: '같은 레코드 · 다른 출력',
    items: [
      { name: 'XAI', kind: '과제 2', json: J({ product_id: A1.product_id, absa_mean: A1.absa_mean, aspects: A1.aspects }) },
      { name: '수요예측', kind: '과제 3', json: J({ product_id: F1.product_id, p10: F1.p10, p50: F1.p50, p90: F1.p90, order: F1.order, status: F1.status }) },
      { name: '이상탐지', kind: '과제 4', json: J({ product_id: N1.product_id, anomaly_score: N1.anomaly_score, state: N1.state, causes: N1.causes }) },
    ],
  },
  {
    kicker: 'JOIN · 합류',
    title: 'product_id로 붙음',
    items: [
      { name: 'XAI 레인', kind: '요인', json: J({ product_id: P1.product_id, xai: { absa_mean: A1.absa_mean, weighted_components: S1.parts.slice(0, 3) } }) },
      { name: '수요 레인', kind: '예측', json: J({ product_id: P1.product_id, forecast: { p50: F1.p50, status: F1.status, order: F1.order } }) },
      { name: '이상 레인', kind: '운영', json: J({ product_id: P1.product_id, anomaly: { score: N1.anomaly_score, state: N1.state } }) },
    ],
  },
  {
    kicker: 'PMF · 가중합',
    title: '시장 적합성',
    items: [
      { name: '시장 성과', kind: '×0.30', json: J({ model: 'market', score: S1.channel_scores.market, weight: 0.30, evidence: S1.parts.find((p) => p.model === 'market')?.evidence }) },
      { name: '고객 반응', kind: '×0.30', json: J({ model: 'xai', score: S1.channel_scores.xai, weight: 0.30, evidence: S1.parts.find((p) => p.model === 'xai')?.evidence }) },
      { name: '수요 전망', kind: '×0.25', json: J({ model: 'forecast', score: S1.channel_scores.forecast, weight: 0.25, evidence: S1.parts.find((p) => p.model === 'forecast')?.evidence }) },
      { name: '운영 안정', kind: '×0.15', json: J({ model: 'anomaly', score: S1.channel_scores.anomaly, weight: 0.15, evidence: S1.parts.find((p) => p.model === 'anomaly')?.evidence }) },
      { name: S1.product_name, kind: `${S1.pmf_score} · ${S1.verdict}`, json: J({ product_id: S1.product_id, formula: S1.formula, pmf_score: S1.pmf_score, verdict: S1.verdict, meaning: S1.meaning }) },
    ],
  },
  {
    kicker: 'SKU · 4상품',
    title: '최종 순위',
    items: PMF_SCORES.map((s, i) => ({
      name: s.product_name,
      kind: `#${i + 1} ${s.pmf_score}`,
      json: J({ rank: i + 1, product_id: s.product_id, pmf_score: s.pmf_score, verdict: s.verdict, meaning: s.meaning, parts: s.channel_scores, weakest: s.weakest }),
    })),
  },
  {
    kicker: 'SUM · 전체',
    title: '한 파이프',
    items: [
      { name: '원천', kind: 'SRC', json: J({ sources: ['web_product', 'review_cs', 'public_data', 'event_log'] }) },
      { name: '패브릭', kind: '01', json: J({ asset: ['envelope', 'kafka', 'vector', 'api'] }) },
      { name: 'XAI', kind: '02', json: J({ output: 'lexicon sentiment + weighted components' }) },
      { name: '수요예측', kind: '03', json: J({ output: 'p10/p50/p90 + reorder' }) },
      { name: '이상탐지', kind: '04', json: J({ output: 'anomaly_score + alert' }) },
      { name: 'PMF', kind: '05', json: J({ formula: S1.formula, scores: PMF_SCORES.map((s) => ({ id: s.product_id, name: s.product_name, pmf: s.pmf_score, verdict: s.verdict })) }) },
    ],
  },
];

const FABRIC = [
  {
    kicker: 'ID · Hybrid Data Fabric',
    title: '모델 카드',
    items: [
      { name: '하이브리드 데이터 패브릭', kind: '과제 1', json: J({ model: 'Hybrid Data Fabric', task: 1, role: '이종 원천 → 표준 자산', layers: ['collect', 'hub', 'process', 'store', 'api'], feeds: ['xai', 'forecast', 'anomaly', 'pmf'] }) },
    ],
  },
  {
    kicker: 'IN · 원천 데이터',
    title: '네 갈래 원본',
    items: [
      { name: 'web_product', kind: 'JSON API', json: J({ product_id: P1.product_id, sku: P1.sku, product_name: P1.product_name, price: P1.price, stock: P1.stock, channel: P1.channel }) },
      { name: 'review_cs', kind: '비정형 텍스트', json: J({ product_id: P1.product_id, sku: P1.sku, reviews: P1.reviews, cs: P1.cs }) },
      { name: 'public_data', kind: '공공·검색 지표', json: J({ ...CATALOG.market, search_interest: P1.search_trend }) },
      { name: 'event_log', kind: 'JSON 이벤트', json: J({ event_type: 'purchase', product_id: P1.product_id, sku: P1.sku, count: P1.ad_metrics.purchase, amount: P1.price * P1.ad_metrics.purchase }) },
    ],
  },
  {
    kicker: 'L1 · 표준 봉투',
    title: 'Layer1 envelope',
    items: PRODUCTS.map((p) => ({
      name: p.product_id,
      kind: 'web_product',
      json: J({ source: 'web_product', record_id: `${p.product_id}-web`, collected_at: `${CATALOG.as_of}T03:44:12Z`, payload: { product_id: p.product_id, sku: p.sku, product_name: p.product_name, price: p.price, stock: p.stock } }),
    })),
  },
  {
    kicker: 'L2 · Kafka 토픽',
    title: '소스 → 토픽',
    items: [
      { name: 'product_signal', kind: 'web_product', json: J({ topic: 'product_signal', record_id: `${P1.product_id}-web`, source: 'web_product', sku: P1.sku }) },
      { name: 'review_stream', kind: 'review_cs', json: J({ topic: 'review_stream', source: 'review_cs', payload: { product_id: P1.product_id, reviews: P1.reviews, cs: P1.cs } }) },
      { name: 'market_stream', kind: 'public_data', json: J({ topic: 'market_stream', source: 'public_data', payload: { ...CATALOG.market, search_interest: P1.search_trend } }) },
      { name: 'sale_event', kind: 'event_log', json: J({ topic: 'sale_event', source: 'event_log', payload: { event_type: 'purchase', product_id: P1.product_id, count: P1.ad_metrics.purchase } }) },
    ],
  },
  {
    kicker: 'L3 · 특징·임베딩',
    title: '분석 가능 자산',
    items: PRODUCTS.map((p) => ({
      name: p.product_name,
      kind: p.product_id,
      json: J({
        record_id: `${p.product_id}-web`,
        features: { price_tier: p.price >= 35000 ? 'mid' : 'value', sentiment_score: ABSA_BY_ID[p.product_id].channel_score, stock: p.stock },
        embedding_model: 'synthetic_3d_demo',
        embedding: demoEmbedding(p),
        llm_context: `[상품] ${p.product_name} ${p.description}`,
      }),
    })),
  },
  {
    kicker: 'L4 · 3중 저장',
    title: 'Hot / Cold / Vector',
    items: [
      { name: 'Redis', kind: 'HOT PATH', json: J({ key: `hot:${P1.product_id}`, ttl_s: 3600, product_name: P1.product_name, stock: P1.stock }) },
      { name: 'Amazon S3', kind: 'COLD PATH', json: J({ uri: `s3://hdf/zone=silver/dt=${CATALOG.as_of}/${P1.product_id}.json` }) },
      { name: 'Milvus', kind: 'VECTOR STORE', json: J({ collection: 'products', id: P1.product_id, dim: 3, embedding_model: 'synthetic_3d_demo' }) },
    ],
  },
  {
    kicker: 'L5 · API',
    title: '검색 응답',
    items: PMF_SCORES.slice(0, 3).map((s, i) => ({
      name: s.product_name,
      kind: `rank ${i + 1}`,
      json: J({ record_id: s.product_id, score: Math.round((s.pmf_score / 100) * 1000) / 1000, score_kind: 'normalized_demo_pmf', product_name: s.product_name, sku: s.sku }),
    })),
  },
  {
    kicker: 'OUT · 산출물',
    title: '표준 자산 4종',
    items: [
      { name: '정제 데이터', kind: 'OUT 01', json: J({ type: 'cleaned_record', product_id: P1.product_id, sku: P1.sku, envelope: true, features: true }) },
      { name: '메시지 토픽', kind: 'OUT 02', json: J({ topics: ['product_signal', 'review_stream', 'market_stream', 'sale_event'] }) },
      { name: '벡터 인덱스', kind: 'OUT 03', json: J({ store: 'milvus', collection: 'products', count: PRODUCTS.length }) },
      { name: '표준화 API', kind: 'OUT 04', json: J({ endpoints: ['/search', '/monitor', '/recommend', '/alert', '/report'] }) },
    ],
  },
  {
    kicker: 'SUM',
    title: '형태 변화',
    items: [
      { name: '입력 → API', kind: '자동화 목표 90% · 미측정', json: J({ in: '소스별 원본', l1: '표준 봉투', l2: 'Kafka 메시지', l3: '특징+임베딩', l4: 'Redis·S3·Milvus', l5: 'REST JSON', products: PRODUCTS.map((p) => p.product_id) }) },
    ],
  },
];

const XAI = [
  {
    kicker: 'ID · XAI PMF Engine',
    title: '모델 카드',
    items: [
      { name: 'XAI PMF Engine', kind: '과제 2', json: J({ model: 'XAI PMF Engine', task: 2, role: '리뷰·광고·판매 → 요인 설명', output: ['factor_importance', 'weighted_components', 'evidence'] }) },
    ],
  },
  {
    kicker: 'IN · 세 갈래',
    title: '리뷰 · 광고 · 판매',
    items: [
      { name: '상품 리뷰·CS', kind: '텍스트', json: J({ product_id: P1.product_id, reviews: P1.reviews, cs: P1.cs, mentions: A1.aspects.filter((a) => a.mentioned).map((a) => a.name) }) },
      { name: '광고 성과', kind: '정형 지표', json: J({ product_id: P1.product_id, ...P1.ad_metrics }) },
      { name: '판매·재고', kind: '정형 테이블', json: J({ product_id: P1.product_id, sku: P1.sku, units: H1.slice(-7).reduce((s, r) => s + r.units, 0), stock: P1.stock, cvr: P1.behavior.cvr }) },
    ],
  },
  {
    kicker: 'L1 · 통합 레코드',
    title: '정합 Feature',
    items: PRODUCTS.map((p) => ({
      name: p.product_name,
      kind: p.product_id,
      json: J({ product_id: p.product_id, sku: p.sku, review_text: p.reviews[0], cs: p.cs, ad_metrics: p.ad_metrics, sales: { units_7d: SALES_BY_ID[p.product_id].slice(-7).reduce((s, r) => s + r.units, 0), stock: p.stock } }),
    })),
  },
  {
    kicker: 'L2 · ABSA',
    title: '속성별 감성',
    items: A1.aspects.map((row) => ({
      name: row.name,
      kind: String(row.score),
      json: J({ product_id: A1.product_id, sku: A1.sku, ...row, model: A1.model }),
    })),
  },
  {
    kicker: 'L3 · 가중 기여',
    title: 'PMF 가중 기여분',
    items: S1.parts.map((row) => ({
      name: row.label,
      kind: String(row.contribution),
      json: J({ product_id: S1.product_id, explanation_method: S1.explanation_method, ...row }),
    })),
  },
  {
    kicker: 'L4 · 전략',
    title: '실행 인사이트',
    items: [
      { name: '광고 전략', kind: 'AD', json: J({ product_id: P1.product_id, roas: P1.ad_metrics.roas, ctr: P1.ad_metrics.ctr, action: P1.ad_metrics.roas >= 3 ? '고성과 소재 확대' : '저성과 광고 축소' }) },
      { name: '상품·CS', kind: 'PRODUCT / CS', json: J({ product_id: P1.product_id, weak_aspects: A1.aspects.filter((a) => a.polarity === 'negative').map((a) => a.name), action: '가격·품질 개선, 문의 대응 우선순위' }) },
      { name: '재고·재판매', kind: 'INVENTORY', json: J({ product_id: P1.product_id, status: F1.status, order: F1.order, action: F1.action }) },
    ],
  },
  {
    kicker: 'ACT',
    title: '실행 과제',
    items: [
      { name: '개선 과제', kind: '01', json: J({ product_id: P1.product_id, focus: A1.aspects.filter((a) => a.polarity === 'negative').map((a) => a.name) }) },
      { name: '프로모션 제안', kind: '02', json: J({ product_id: P1.product_id, ctr: P1.ad_metrics.ctr, roas: P1.ad_metrics.roas, auto: ['소재', '타겟', '전략'] }) },
      { name: '재고 최적화', kind: '03', json: J({ product_id: P1.product_id, ...FORECAST_BY_ID[P1.product_id], basis: ['수요', '회전', '성과'] }) },
      { name: '확산 인사이트', kind: '04', json: J({ share: true, monitor: true, weighted_components: S1.parts[0] }) },
    ],
  },
  {
    kicker: 'OUT',
    title: '산출물 4종',
    items: [
      { name: '감성 리포트', kind: 'OUT 01', json: J({ type: 'absa_report', ...A1 }) },
      { name: 'XAI 요인 리포트', kind: 'OUT 02', json: J({ type: 'weighted_components', product_id: S1.product_id, weighted_components: S1.parts }) },
      { name: '우선순위 대시보드', kind: 'OUT 03', json: J({ type: 'action_board', status: F1.status, weak_aspects: A1.aspects.filter((a) => a.polarity === 'negative') }) },
      { name: '전략추천 API', kind: 'OUT 04', json: J({ type: 'strategy_api', product_id: P1.product_id, action: F1.action }) },
    ],
  },
  {
    kicker: 'SUM',
    title: '기획 목표 74% → 90% · 미측정',
    items: [
      { name: 'PMF-ROAS 일치도 목표', kind: '90% · 검증 전', json: J({ pmf_score: S1.pmf_score, roas: P1.ad_metrics.roas, weighted_components: S1.parts[0], review_count: A1.review_count }) },
    ],
  },
];

const FORECAST = [
  {
    kicker: 'ID · Demand Forecast',
    title: '모델 카드',
    items: [
      { name: '수요예측 엔진', kind: '과제 3', json: J({ model: 'Demand Forecast', task: 3, role: '시계열 → p10/p50/p90', output: ['quantile_forecast', 'inventory_action'] }) },
    ],
  },
  {
    kicker: 'IN · 두 축',
    title: '판매 + 실시간',
    items: [
      { name: '내부 판매', kind: '시계열', json: J({ sku: P1.sku, sales_history: H1.slice(-14).map((r) => r.units) }) },
      { name: '외부 지표', kind: '계절·검색·프로모션', json: J({ seasonal_idx: P1.sales_seed.seasonal, search_index: P1.search_trend.index, cpi: CATALOG.market.value, promo: P1.sales_seed.promo_day >= 0 }) },
      { name: '실시간 반응', kind: '이벤트 스트림', json: J({ product_id: P1.product_id, views: P1.behavior.views, carts: P1.behavior.carts, cvr: P1.behavior.cvr }) },
    ],
  },
  {
    kicker: 'L1 · 피처',
    title: '예측용 피처셋',
    items: PRODUCTS.map((p) => {
      const h = SALES_BY_ID[p.product_id];
      return {
        name: p.sku,
        kind: '정규화 피처',
        json: J({ sku: p.sku, date: CATALOG.as_of, sales_lag_7: h.slice(-7).reduce((s, r) => s + r.units, 0), sales_lag_1: h[h.length - 1].units, is_holiday: false, seasonal_idx: p.sales_seed.seasonal, search_index: p.search_trend.index, promo: p.sales_seed.promo_day >= 0 }),
      };
    }),
  },
  {
    kicker: 'L2 · 선형 기준선',
    title: '모델 설정',
    items: [
      { name: '선형 추세 + 잔차 근사', kind: F1.model, json: J({ model: F1.model, interval_method: F1.interval_method, evaluation: F1.evaluation, lookback: F1.lookback, horizon: F1.horizon, quantiles: [0.1, 0.5, 0.9] }) },
    ],
  },
  {
    kicker: 'L3 · p10/p50/p90',
    title: '잔차 기반 구간 근사',
    items: PRODUCTS.map((p) => {
      const f = FORECAST_BY_ID[p.product_id];
      return { name: p.product_name, kind: f.status, json: J({ product_id: f.product_id, sku: f.sku, p10: f.p10, p50: f.p50, p90: f.p90, stock: f.stock, status: f.status, order: f.order }) };
    }),
  },
  {
    kicker: 'L4 · 재고',
    title: '발주 액션',
    items: [
      { name: 'Safety Stock', kind: 'S', json: J({ sku: F1.sku, safety_stock: F1.safety_stock }) },
      { name: '재고 충족률', kind: 'R', json: J({ sku: F1.sku, stock: F1.stock, demand_4w: F1.demand_4w, cover: Math.round((F1.stock / F1.demand_4w) * 100) / 100 }) },
      { name: '액션 추천', kind: F1.status, json: J({ sku: F1.sku, action: F1.action, qty: F1.order, status: F1.status }) },
    ],
  },
  {
    kicker: 'RPT',
    title: '4주 발주 리포트',
    items: PRODUCTS.map((p) => {
      const f = FORECAST_BY_ID[p.product_id];
      return { name: p.product_name, kind: f.status, json: J({ sku: f.sku, stock: f.stock, demand_4w: f.demand_4w, order: f.order, status: f.status, action: f.action }) };
    }),
  },
  {
    kicker: 'OUT',
    title: '산출물 4종',
    items: [
      { name: '모델 입력 데이터셋', kind: 'OUT 01', json: J({ type: 'feature_set', lookback: F1.lookback, skus: PRODUCTS.map((p) => p.sku) }) },
      { name: '선형 기준선', kind: 'OUT 02', json: J({ type: 'linear_baseline_config', model: F1.model, horizon: F1.horizon }) },
      { name: '확률적 예측', kind: 'OUT 03', json: J({ type: 'p10_p50_p90', rows: PRODUCTS.map((p) => ({ sku: p.sku, ...FORECAST_BY_ID[p.product_id] })).map((r) => ({ sku: r.sku, p10: r.p10, p50: r.p50, p90: r.p90 })) }) },
      { name: '재고 액션추천', kind: 'OUT 04', json: J({ type: 'reorder_api', sku: F1.sku, action: F1.action, qty: F1.order }) },
    ],
  },
  {
    kicker: 'SUM',
    title: '기획 목표 70% → 90% · 미측정',
    items: [
      { name: '수요 추정 예시 · 정확도 미검증', kind: F1.status, json: J({ sku: F1.sku, p10: F1.p10, p50: F1.p50, p90: F1.p90, status: F1.status, order: F1.order }) },
    ],
  },
];

const ANOMALY = [
  {
    kicker: 'ID · Anomaly Detection',
    title: '모델 카드',
    items: [
      { name: '이상탐지 엔진', kind: '과제 4', json: J({ model: 'Anomaly Detection', task: 4, role: '스트림 → 이상 점수', output: ['anomaly_score', 'alert'] }) },
    ],
  },
  {
    kicker: 'IN · 스트림',
    title: '모의 카탈로그 4종 · 처리량 미측정',
    items: PRODUCTS.map((p) => ({
      name: p.product_name,
      kind: '스트리밍 로그',
      json: J({ ts: `${CATALOG.as_of}T10:24:15Z`, product_id: p.product_id, sku: p.sku, orders: p.ad_metrics.purchase, stock: p.stock, ctr: p.ad_metrics.ctr, roas: p.ad_metrics.roas, cvr: p.behavior.cvr }),
    })),
  },
  {
    kicker: 'L1 · Baseline',
    title: '카탈로그 z-score 기준선',
    items: [
      { name: '정상 패턴 모델', kind: N1.model, json: J({ model: N1.model, baseline_as_of: CATALOG.as_of, distance_threshold: N1.threshold, features: ['orders', 'stock', 'ctr', 'roas', 'cvr', 'price'] }) },
    ],
  },
  {
    kicker: 'L2 · 탐지',
    title: 'Anomaly Score',
    items: PRODUCTS.map((p) => {
      const n = ANOMALY_BY_ID[p.product_id];
      return { name: p.product_name, kind: `${n.state} ${n.anomaly_score}`, json: J({ product_id: n.product_id, sku: n.sku, anomaly_score: n.anomaly_score, state: n.state, standardized_distance: n.standardized_distance, explanation_method: n.explanation_method, causes: n.causes }) };
    }),
  },
  {
    kicker: 'L3 · 지표별 거리 비중',
    title: '원인 후보 · 인과관계 미검증',
    items: N1.causes.map((row) => ({
      name: row.factor,
      kind: String(row.contribution),
      json: J({ product_id: N1.product_id, sku: N1.sku, anomaly_score: N1.anomaly_score, state: N1.state, ...row }),
    })),
  },
  {
    kicker: 'L4 · 알림',
    title: '리포트 연계',
    items: [
      { name: '리포트 연계 예시', kind: N1.state, json: J({ channel: 'gemini', sent: false, product_id: N1.product_id, anomaly_score: N1.anomaly_score, top_cause: N1.causes[0] }) },
      { name: 'Slack / SMS', kind: '알림', json: J({ channel: 'slack', sent: false, to: '박지훈(운영)', sku: N1.sku, state: N1.state }) },
      { name: '대시보드', kind: '실시간', json: J({ channel: 'dashboard', live: false, product_id: N1.product_id, score: N1.anomaly_score }) },
    ],
  },
  {
    kicker: 'ALT',
    title: '알람 로그',
    items: PRODUCTS.map((p, i) => {
      const n = ANOMALY_BY_ID[p.product_id];
      const channels = ['Slack', 'Email', 'SMS', 'Dashboard'];
      const owners = ['박지훈', '김수진', '최호진', '이서연'];
      return {
        name: p.product_name,
        kind: n.state,
        json: J({ at: `10:${String(24 - i * 7).padStart(2, '0')}:15`, product_id: p.product_id, sku: p.sku, type: n.causes[0].factor, state: n.state, sent: false, score: n.anomaly_score, action: FORECAST_BY_ID[p.product_id].action, channel: channels[i], owner: owners[i] }),
      };
    }),
  },
  {
    kicker: 'OUT',
    title: '산출물 4종',
    items: [
      { name: '정상 기준선 모델', kind: 'OUT 01', json: J({ type: 'zscore_baseline', model: N1.model, threshold: N1.threshold }) },
      { name: '이상탐지 결과', kind: 'OUT 02', json: J({ type: 'anomaly_score', rows: PRODUCTS.map((p) => ({ sku: p.sku, ...ANOMALY_BY_ID[p.product_id] })).map((r) => ({ sku: r.sku, score: r.anomaly_score, state: r.state })) }) },
      { name: '원인진단 리포트', kind: 'OUT 03', json: J({ type: 'squared_zscore_share', product_id: N1.product_id, causes: N1.causes }) },
      { name: '알림·대시보드', kind: 'OUT 04', json: J({ type: 'alert_link', sent: false, sku: N1.sku, state: N1.state, score: N1.anomaly_score }) },
    ],
  },
  {
    kicker: 'SUM',
    title: '대응 목표: 1일1회 → 실시간 · 미측정',
    items: [
      { name: '대응 시간', kind: N1.state, json: J({ sku: N1.sku, anomaly_score: N1.anomaly_score, state: N1.state, top_cause: N1.causes[0], action: F1.action }) },
    ],
  },
];

const PMF = [
  {
    kicker: 'ID · Multimodal PMF',
    title: '모델 카드',
    items: [
      { name: '멀티모달 PMF', kind: '과제 5', json: J({ model: 'pmf_model_fusion_v1', task: 5, role: 'XAI·수요·이상·시장성과 합산 → 시장 적합성', formula: S1.formula, output: ['pmf_score', 'verdict', 'parts', 'reasons'] }) },
    ],
  },
  {
    kicker: 'IN · 4모델',
    title: '합산 입력',
    items: [
      { name: '시장 성과', kind: '광고·행동', json: J({ product_id: P1.product_id, source: 'fabric', ...P1.ad_metrics, behavior: P1.behavior }) },
      { name: 'XAI 고객 반응', kind: '과제 2', json: J({ product_id: P1.product_id, source: 'xai', absa_mean: A1.absa_mean, aspects: A1.aspects }) },
      { name: '수요 전망', kind: '과제 3', json: J({ product_id: P1.product_id, source: 'forecast', p10: F1.p10, p50: F1.p50, p90: F1.p90, status: F1.status }) },
      { name: '운영 안정', kind: '과제 4', json: J({ product_id: P1.product_id, source: 'anomaly', anomaly_score: N1.anomaly_score, state: N1.state, causes: N1.causes }) },
    ],
  },
  {
    kicker: 'S1 · 모델 점수',
    title: '모델별 0~100',
    items: S1.parts.map((row) => ({
      name: row.label,
      kind: String(row.score),
      json: J({ product_id: S1.product_id, model: row.model, score: row.score, evidence: row.evidence }),
    })),
  },
  {
    kicker: 'S2 · 가중합',
    title: '설명가능 융합',
    items: [
      { name: S1.product_name, kind: `${S1.pmf_score} · ${S1.verdict}`, json: J({ product_id: S1.product_id, formula: S1.formula, parts: S1.parts.map((p) => ({ model: p.model, label: p.label, score: p.score, weight: p.weight, contribution: p.contribution })), pmf_score: S1.pmf_score, verdict: S1.verdict }) },
    ],
  },
  {
    kicker: 'S3 · 모델 기여',
    title: '설명가능 합산',
    items: S1.parts.map((row) => ({
      name: row.label,
      kind: `${row.contribution}`,
      json: J({ product_id: S1.product_id, model: row.model, label: row.label, score: row.score, weight: row.weight, contribution: row.contribution, evidence: row.evidence }),
    })),
  },
  {
    kicker: 'S4 · 시장 적합성',
    title: '최종 PMF',
    items: PMF_SCORES.map((s) => ({
      name: s.product_name,
      kind: `${s.pmf_score} · ${s.verdict}`,
      json: J({
        product_id: s.product_id,
        sku: s.sku,
        pmf_score: s.pmf_score,
        verdict: s.verdict,
        meaning: s.meaning,
        formula: s.formula,
        parts: s.parts.map((p) => ({ model: p.model, label: p.label, score: p.score, weight: p.weight, contribution: p.contribution })),
        reasons: s.reasons,
        confidence: s.confidence,
        confidence_kind: s.confidence_kind,
      }),
    })),
  },
  {
    kicker: 'QTY',
    title: '상품 순위',
    items: PMF_SCORES.map((s, i) => ({
      name: s.product_name,
      kind: `#${i + 1} ${s.pmf_score}`,
      json: J({ rank: i + 1, product_id: s.product_id, pmf_score: s.pmf_score, verdict: s.verdict, meaning: s.meaning, weakest: s.weakest }),
    })),
  },
  {
    kicker: 'OUT',
    title: '산출물 4종',
    items: [
      { name: 'PMF Score', kind: 'OUT 01', json: J({ type: 'market_fit_score', rows: PMF_SCORES.map((s) => ({ id: s.product_id, name: s.product_name, pmf: s.pmf_score, verdict: s.verdict })) }) },
      { name: '모델 기여 리포트', kind: 'OUT 02', json: J({ type: 'explainable_parts', product_id: S1.product_id, parts: S1.parts }) },
      { name: '약점 근거', kind: 'OUT 03', json: J({ type: 'reasons', product_id: S1.product_id, reasons: S1.reasons }) },
      { name: '판정', kind: 'OUT 04', json: J({ type: 'verdict', product_id: S1.product_id, pmf_score: S1.pmf_score, verdict: S1.verdict, meaning: S1.meaning }) },
    ],
  },
  {
    kicker: 'SUM',
    title: '시장에서 얼마나 먹히나',
    items: [
      { name: '시장 적합성', kind: 'PMF', json: J({ formula: S1.formula, scores: PMF_SCORES.map((s) => ({ id: s.product_id, name: s.product_name, pmf: s.pmf_score, verdict: s.verdict, parts: s.channel_scores })) }) },
    ],
  },
];

const DECK_SAMPLES = { overview: OVERVIEW, fabric: FABRIC, xai: XAI, forecast: FORECAST, anomaly: ANOMALY, pmf: PMF };

function stagePack(model, stage) {
  const deck = Object.prototype.hasOwnProperty.call(DECK_SAMPLES, model) ? DECK_SAMPLES[model] : DECK_SAMPLES.fabric;
  const index = Number.isInteger(stage) && stage >= 0 && stage < deck.length ? stage : 0;
  return deck[index];
}

function sampleView(pack, group, instanceId = group) {
  const item = pack.items[group];
  return {
    instanceId,
    group,
    groups: pack.items.length,
    kicker: pack.kicker,
    title: pack.title,
    name: item.name,
    kind: item.kind,
    json: item.json,
  };
}

/** The unique stage samples, in the same order used to map particle IDs. */
export function getStageSamples(model, stage) {
  const pack = stagePack(model, stage);
  return pack.items.map((_, group) => sampleView(pack, group));
}

export function inspectParticle(model, stage, instanceId) {
  const pack = stagePack(model, stage);
  const id = Number.isInteger(instanceId) ? instanceId : 0;
  const group = ((id % pack.items.length) + pack.items.length) % pack.items.length;
  return sampleView(pack, group, id);
}
